var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15.086A7.086 7.086 0 1 0 8 .915a7.086 7.086 0 0 0 0 14.171M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.6-7.142a.6.6 0 0 1-1.2 0l-.214-4.287a.815.815 0 1 1 1.629 0zM8 10.572a.857.857 0 1 1 0 1.714.857.857 0 0 1 0-1.714",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;